import { createContext } from 'react';

const UserReactionContext = createContext<any>({});

export default UserReactionContext;
